import CustomersCreate from "@/Customer/CustomersCreate.vue";
import CustomersIndex from "@/Customer/CustomersIndex.vue";
import CustomersShow from "@/Customer/CustomersShow.vue";

export default [
  {
    path: "/customers",
    name: "CustomersIndex",
    component: CustomersIndex,
    meta: {
      permissionRoles: ["customers"],
      activeRoutes: ["/customers/:id", "/customers/new"]
    }
  },
  {
    path: "/customers/new",
    name: "CustomersCreate",
    component: CustomersCreate,
    meta: {
      permissionRoles: ["customers"]
    }
  },
  {
    path: "/customers/:id",
    name: "CustomersShow",
    component: CustomersShow,
    meta: {
      permissionRoles: ["customers"]
    }
  }
];
